/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { VApplication } from '../../../../../application';
import { LoggerModule } from '@vlinder-web/logger-module-react';
import { ProvisionalDetailPageService } from '@pages/ProvisionalDetailPage/services';

const MODULE_NAME = 'ProvisionalDetailPage.machines.states.TransactionList';
const log: any = LoggerModule?.getInstance();

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.ProvisionalDetailPageService'
  ) as ProvisionalDetailPageService;
};

export const getTransactionList = async (context: any, event: any) => {
  const currentState = 'GET_PAGE_CONTENT';
  const method = 'getTransactionList';

  return new Promise(async (resolve, reject) => {
    try {
      log.blue(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent?.getGetTransactionList();

      if (content) {
        return resolve({
          key: 'GET_TRANSACTION_LIST',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'GET_TRANSACTION_LIST_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'GET_TRANSACTION_LIST_ERROR',
        value: _msg,
      });
    }
  });
};
